/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createTemplate.defs.js'
export { main as default } from './createTemplate.defs.js'
